
import { Request } from "@cttq/cttq-request";

let serverInstance = new Request({
	baseURL: import.meta.env.VITE_SUPPLIER_URL,
});


export function getSupplierList(data: any){
	return serverInstance.post({
		url: `/supplier/normal/searchSupplierForFrontComponent`,
		data
	});
}


